import { Component, OnInit, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-shield-guard-icon',
  templateUrl: './shield-guard-icon.component.html',
  styleUrls: ['./shield-guard-icon.component.scss'],
})
export class ShieldGuardIconComponent implements OnInit {
  @Input() isMeterLicensed = false;
  @Input() alarmCount = 0;
  @Input() isIconForHomeScreen = false;
  @Input() isIconForDetail = false;
  @Input() badgeVisible = true;
  @Input() isIconForMapScreen = false;

  hasAlarm = false;
  isActiveAlarm = false;

  showDelay = new FormControl(500);
  hideDelay = new FormControl(500);
  position = new FormControl('left');

  hasActiveAlarmTooltip = '';
  hasMultipleActiveAlarmsTooltip = '';
  unLicensedMeterTooltip = '';
  hasNoActiveAlarmWithLicenseTooltip = '';

  constructor(public translate: TranslateService) {}

  public ngOnInit(): void {
    this.hasAlarm = this.alarmCount > 0;
    this.isActiveAlarm = this.hasAlarm && this.isMeterLicensed;
    this.isIconForDetail = !this.isIconForHomeScreen && this.isIconForDetail;
    this.translate.get('module.energyGuard.common.shieldIcon').subscribe((text) => {
      this.hasActiveAlarmTooltip = text.hasActiveAlarmTooltip;
      this.hasMultipleActiveAlarmsTooltip = text.hasMultipleActiveAlarmsTooltip;
      this.hasNoActiveAlarmWithLicenseTooltip = text.hasNoActiveAlarmWithLicenseTooltip;
      this.unLicensedMeterTooltip = '';
    });
  }

  public getToolTipText(): string {
    let toolTip = this.unLicensedMeterTooltip;

    if (this.isMeterLicensed) {
      toolTip =
        this.alarmCount <= 0
          ? this.hasNoActiveAlarmWithLicenseTooltip
          : this.alarmCount === 1
          ? this.hasActiveAlarmTooltip
          : this.hasMultipleActiveAlarmsTooltip;
    }
    return toolTip;
  }
}
